import { Button, Grid, GridItem, Input, useToast } from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { useMutation } from 'react-query'
import { api } from '../../../services/api'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputFloating from '../../../components/InputFloating'

const schema = yup.object().shape({
  nunota: yup.string().required('N. Nota obrigatório'),
  quantidade: yup.string().required('Quantidade do Produto obrigatório'),
  codproduto: yup.string().required('Código do Produto obrigatório'),
  qtdetiqueta: yup.string().required('Quantidade de etiqueta obrigatório'),
})

async function gerarEtiqueta({ nunota, quantidade, codproduto, qtdetiqueta }) {
  try {
    // const response = await api.get(
    //   `/site/v2/orcamento/gerar-etiqueta-manual/${nunota}/${quantidade}/${codproduto}/${qtdetiqueta}`,
    //   { responseType: 'arraybuffer' }
    // )

    // const blob = new Blob([response.data], { type: 'application/pdf' })

    // const link = document.createElement('a')
    // link.href = window.URL.createObjectURL(blob)
    // link.download = `etiqueta-${nunota}.pdf`

    // //abrir em nova aba

    // link.target = '_blank'
    // link.rel = 'noopener noreferrer'

    // document.body.appendChild(link)
    // link.click()

    // document.body.removeChild(link)

    //abrindo em nova aba
    window.open(
      `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/gerar-etiqueta-manual/${nunota}/${quantidade}/${codproduto}/${qtdetiqueta}`,
      '_blank'
    )
  } catch (error) {
    console.error('Erro ao gerar etiqueta:', error)
  }
}

export function GerarEtiqueta() {
  const { handleSubmit, register } = useForm({
    resolver: yupResolver(schema),
  })

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
  })

  const { data, mutateAsync, isLoading } = useMutation({
    mutationKey: 'gerarEtiqueta',
    mutationFn: gerarEtiqueta,
    onSuccess: (data) => {
      toast({
        title: 'Etiqueta gerada com sucesso!',
        description: 'Etiqueta gerada com sucesso!',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao gerar etiqueta!',
        description: 'Entre em contato com a equipe de desenvolvimento!',
        status: 'error',
      })
    },
  })

  async function handleGenerateEtiqueta(data) {
    try {
      await mutateAsync({
        nunota: data.nunota,
        quantidade: data.quantidade,
        codproduto: data.codproduto,
        qtdetiqueta: data.qtdetiqueta,
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <HeadingPages name="Gerar Etiqueta" />

      <Layout>
        <Grid
          templateColumns="repeat(2, 1fr)"
          gap={6}
          mt="6"
          alignItems="center"
          maxW="container.md"
          mx="auto"
          as="form"
          onSubmit={handleSubmit(handleGenerateEtiqueta)}
        >
          <GridItem>
            <InputFloating placeholder="N. Nota" {...register('nunota')} label="N. Nota" />
          </GridItem>
          <GridItem>
            <InputFloating placeholder="Quantidade do Produto" {...register('quantidade')} label="Quantidade do Produto" />
          </GridItem>
          <GridItem>
            <InputFloating placeholder="Código do Produto" {...register('codproduto')} label="Código do Produto" />
          </GridItem>
          <GridItem>
            <InputFloating placeholder="Quantidade de etiqueta" {...register('qtdetiqueta')} label="Quantidade de etiqueta" />
          </GridItem>
          <GridItem colSpan={2}>
            <Button w="100%" colorScheme="blue" type="submit" isLoading={isLoading}>
              Gerar Etiqueta
            </Button>
          </GridItem>
        </Grid>
      </Layout>
    </>
  )
}
